import { render, staticRenderFns } from "./GenericDates.vue?vue&type=template&id=7ffd5824"
import script from "./GenericDates.vue?vue&type=script&lang=ts"
export * from "./GenericDates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports